var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../static/404.png"),"alt":""}}),_c('div',{staticClass:"error"},[_vm._v("404")]),_c('van-button',{staticStyle:{"width":"35%"},attrs:{"round":"","type":"info"},on:{"click":_vm.toFresh}},[_vm._v("刷新")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }